export default [
    {
        path: '/login',
        component: () => import('./pages/Login'),
        name: 'login',
        meta: {
            public: true,
            hiddenFromMenu: true,
            label: 'Login'
        }
    },
    {
        path: '/oauth/auth',
        component: () => import('~/core/components/Page'),
        name: 'authorize',
        meta: {
            hiddenFromMenu: true,
            label: 'authorize'
        }
    },
    {
        path: '/v2',
        component: () => import('~/core/components/LegacyPage'),
        name: 'v2',
        meta: {
            legacyPath: '/v2',
            label: 'New Wave',
            icon: 'fa fa-star',
            permissions: [
                'v2.view'
            ]
        }
    },
    {
        path: '/manage',
        component: () => import('./pages/Dashboard'),
        name: 'dashboard',
        meta: {
            label: 'Dashboard',
            icon: 'ion-pie-graph'
        }
    },
    {
        path: '/manage/booking-management',
        name: 'booking-management',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Booking Management',
            icon: 'fa fa-briefcase',
            permissions: [
                'agents.wave.login',
            ]
        },
        children: [
            {
                path: 'bookings',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.orders',
                meta: {
                    legacyPath: '/admin/orders',
                    label: 'View Bookings',
                }
            }
            ]
    },
    {
        path: '/manage/booking-management',
        name: 'booking-management',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Booking Management',
            icon: 'fa fa-briefcase',
            permissions: [
                'bookings.list',
            ]
        },
        children: [
            {
                path: 'bookings',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.orders',
                meta: {
                    legacyPath: '/admin/orders',
                    label: 'View Bookings',
                }
            },
            {
                path: 'berthing',
                component: () => import('~/domain/bookings/pages/Berthing'),
                name: 'booking-management.berthing',
                meta: {
                    label: 'Berthing',
                }
            },
            {
                path: 'bookings-notifications',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.bookings-notifications',
                meta: {
                    legacyPath: '/admin/bookings-notifications',
                    label: 'Bookings Notifications',
                }
            },
            {
                path: 'availability',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.availability',
                meta: {
                    legacyPath: '/admin/availability',
                    label: 'Cabin Availability',
                }
            },
            {
                path: 'cabin-availability-summary-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.cabin-availability-summary-report',
                meta: {
                    legacyPath: '/admin/cabin-availability-summary-report',
                    label: 'Cabin Availability Report',
                }
            },
            {
                path: 'cabin-hold',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.cabin-hold',
                meta: {
                    legacyPath: '/admin/cabin-hold',
                    label: 'Hold Cabins',
                }
            },
            {
                path: 'passenger-services',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.passenger-services',
                meta: {
                    legacyPath: '/admin/passenger-services',
                    label: 'Passenger Services',
                }
            },
            {
                path: 'passenger-details',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.passenger-details',
                meta: {
                    legacyPath: '/admin/passenger-details',
                    label: 'Passenger Details',
                }
            },
            {
                path: 'send-tickets',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.send-tickets',
                meta: {
                    legacyPath: '/admin/send-tickets',
                    label: 'Send Tickets',
                }
            },
            {
                path: 'availability-log',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.availability-log',
                meta: {
                    legacyPath: '/admin/availability-log',
                    label: 'Cabin Availability Log',
                }
            },
            {
                path: 'coaches',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.coaches',
                meta: {
                    legacyPath: '/admin/coaches',
                    label: 'View Coaches',
                }
            },
            {
                path: 'cancellation-reasons',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.cancellation-reasons',
                meta: {
                    legacyPath: '/admin/cancellation-reasons',
                    label: 'View Cancellation Reasons',
                    permissions: [
                        'cancellation-reasons.view'
                    ]
                }
            },
            {
                path: 'parking',
                component: () => import('~/domain/ancillaries/pages/ParkingOptions'),
                name: 'booking-management.parking',
                meta: {
                    label: 'View Parking',
                    hideChildren: true,
                    sectionLink: 'index',
                },
                children: [
                    {
                        path: 'index',
                        component: () => import('./domain/ancillaries/pages/parking-options/Index'),
                        name: 'ancillaries.index'
                    },
                ]
            },
            {
                path: 'flights',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.flights',
                meta: {
                    legacyPath: '/admin/flights',
                    label: 'Flights',
                }
            },
            {
                path: 'order-additional-services',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.order-additional-services',
                meta: {
                    legacyPath: '/admin/order-additional-services',
                    label: 'Additional Service Prices',
                }
            },
            {
                path: 'orders-additional',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.orders-additional',
                meta: {
                    legacyPath: '/admin/orders-additional',
                    label: 'Additional Services Bookings',
                }
            },
            {
                path: 'additions-packages',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.additions-packages',
                meta: {
                    legacyPath: '/admin/additions-packages',
                    label: 'Ambassador Moments',
                }
            },
            {
                path: 'additions-packages-discount',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.additions-packages-discount',
                meta: {
                    legacyPath: '/admin/additions-packages-discount',
                    label: 'Ambassador Moments Discount',
                }
            },
        ]
    },

    {
        path: '/manage/enquiry-management',
        name: 'Enquiries',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Enquiry Management',
            icon: 'fa fa-briefcase',
            permissions: [
                'enquiries.*',
                'enquiries.view',
                'enquiries.create'
            ]
        },
        children: [
            {
                path: 'enquiries',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-management.enquiries',
                meta: {
                    legacyPath: '/admin/enquiries',
                    label: 'Enquiries',
                    permissions: [
                        'enquiries.*',
                        'enquiries.view',
                    ]
                },
            },
            {
                path: ':enq',
                component: () => import('~/domain/Enquiries/pages/enquiry'),
                name: 'updateEnquiry',
                meta: {
                    label: 'Update Enquiry',
                    hiddenFromMenu: true,
                }
            },
            {
                path: 'new',
                component: () => import('~/domain/Enquiries/pages/enquiry'),
                name: 'newEnquiry',
                meta: {
                    label: 'New Enquiry',
                    permissions: [
                        'enquiries.*',
                        'enquiries.create',
                    ]
                },
            },
        ]
    },


    {
        path: '/manage/mas',
        name: 'mas',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'My Ambassador Sailing',
            icon: 'fa fa-list-alt',
            permissions: [
                'mas.dest-ex',
                'mas.guest.list',
                'mas.settings.view',
            ]
        },
        children: [
            {
                path: 'settings',
                component: () => import('~/domain/mas/pages/Settings'),
                name: 'mas.settings',
                meta: {
                    label: 'Settings',
                    hideChildren: true,
                    icon: 'ion-settings',
                    sectionLink: 'index',
                    permissions: [
                        'mas.settings.view',
                    ]
                },
                children: [
                    {
                        path: 'index',
                        component: () => import('./domain/mas/pages/settings/Index'),
                        name: 'mas.settings.index'
                    },
                ]
            },{
                path: 'destination-experiences',
                component: () => import('~/domain/mas/pages/DestinationExperiences'),
                name: 'mas.destination-experiences',
                meta: {
                    label: 'Destination Experiences',
                    permissions: [
                        'mas.dest-ex',
                    ]
                }
            },{
                path: 'guest',
                component: () => import('~/domain/mas/pages/Guests'),
                name: 'mas.guest',
                meta: {
                    label: 'Guests',
                    hideChildren: true,
                    icon: 'ion-person',
                    sectionLink: 'index',
                    permissions: [
                        'mas.guest.list',
                    ]
                },
                children: [
                    {
                        path: 'index',
                        component: () => import('./domain/mas/pages/guests/Index'),
                        name: 'mas.guest.index'
                    },
                ]
            },
        ]
    },
    {
        path: '/manage/investor-reports',
        name: 'investor-reports',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Management Reports',
            icon: 'fa fa-list-alt',
            permissions: [
                'investor.reporting'
            ]
        },
        children: [
            {
                path: 'sales-report-cruise',
                component: () => import('~/core/components/LegacyPage'),
                name: 'investor-reports.cumulative-sales-report-by-cruise',
                meta: {
                    legacyPath: '/admin/sales-report-cruise',
                    label: 'Cumulative by Cruise',
                    permissions: [
                        'investor.reporting.sales',
                    ]
                }
            },
            {
                path: 'sales-report-channel',
                component: () => import('~/core/components/LegacyPage'),
                name: 'investor-reports.cumulative-sales-report-by-channel',
                meta: {
                    legacyPath: '/admin/sales-report-channel',
                    label: 'Cumulative by Channel',
                    permissions: [
                        'investor.reporting.sales',
                    ]
                }
            },
            {
                path: 'sales-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'investor-reports.cumulative-sales-report',
                meta: {
                    legacyPath: '/admin/sales-report',
                    label: 'Daily Cumulative Revenues',
                    permissions: [
                        'investor.reporting.sales',
                    ]
                }
            },
        ]
    },
    {
        path: '/manage/booking-reports',
        name: 'booking-reports',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Booking Reports',
            icon: 'fa fa-list-alt',
            permissions: [
                'reporting.view'
            ]
        },
        children: [
            {
                path: 'balances',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.balances',
                meta: {
                    legacyPath: '/admin/balances',
                    label: 'Outstanding Balances',
                }
            },
            {
                path: 'financial-payments-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.financial-payments-report',
                meta: {
                    legacyPath: '/admin/financial-payments-report',
                    label: 'Payment Dates',
                }
            },
            {
                path: 'report-payments',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.report-payments',
                meta: {
                    legacyPath: '/admin/report-payments',
                    label: 'Payments Report',
                }
            },
            {
                path: 'payment-data',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.payment-data',
                meta: {
                    legacyPath: '/admin/payment-data',
                    label: 'Payment Data',
                }
            },
            {
                path: 'report-orders',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.report-orders',
                meta: {
                    legacyPath: '/admin/report-orders',
                    label: 'Bookings Report',
                }
            },
            {
                path: 'report-orders-changes',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.report-orders-changes',
                meta: {
                    legacyPath: '/admin/report-orders-changes',
                    label: 'Bookings Changes Report',
                }
            },
            {
                path: 'margin-revenue-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.margin-revenue-report',
                meta: {
                    legacyPath: '/admin/margin-revenue-report',
                    label: 'Margin & Revenue',
                }
            },
            {
                path: 'cash-summary-ship',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.cash-summary-ship',
                meta: {
                    legacyPath: '/admin/cash-summary-ship',
                    label: 'Cash Summary by Ship',
                }
            },
            {
                path: 'season-by-ship',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.season-by-ship',
                meta: {
                    legacyPath: '/admin/season-by-ship',
                    label: 'Season By Cruise',
                }
            },
            {
                path: 'season-by-agent',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.season-by-agent',
                meta: {
                    legacyPath: '/admin/season-by-agent',
                    label: 'Season By Agent',
                }
            },
            {
                path: 'ancillary-margin-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.ancillary-margin-report',
                meta: {
                    legacyPath: '/admin/ancillary-margin-report',
                    label: 'Ancillary Margin',
                }
            },
            {
                path: 'option-orders',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.option-orders',
                meta: {
                    legacyPath: '/admin/option-orders',
                    label: 'Option Bookings',
                }
            },
            {
                path: 'part-cancellation-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.part-cancellation-report',
                meta: {
                    legacyPath: '/admin/part-cancellation-report',
                    label: 'Part Cancellation',
                }
            },
            {
                path: 'cancellation-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.cancellation-report',
                meta: {
                    legacyPath: '/admin/cancellation-report',
                    label: 'Cancellation',
                }
            },
            {
                path: 'combination-passengers-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.combination-passengers-report',
                meta: {
                    legacyPath: '/admin/combination-passengers-report',
                    label: 'Combination Passengers',
                }
            },
            {
                path: 'cross-cabin-status-check',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.cross-cabin-status-check',
                meta: {
                    legacyPath: '/admin/cross-cabin-status-check',
                    label: 'Combination Check',
                }
            },
            {
                path: 'club-columbus-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.club-columbus-report',
                meta: {
                    legacyPath: '/admin/club-columbus-report',
                    label: 'Club Columbus Report',
                }
            },
            {
                path: 'medical-reports',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.medical-reports',
                meta: {
                    legacyPath: '/admin/medical-reports',
                    label: 'Medical Reports',
                }
            },
            {
                path: 'missing-contact-details-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.missing-contact-details-report',
                meta: {
                    legacyPath: '/admin/missing-contact-details-report',
                    label: 'Missing contact details',
                }
            }
        ]
    },
    {
        path: '/manage/manifests',
        name: 'manifests',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Manifests',
            icon: 'fa fa-list',
            permissions: [
                'cruises.view',
            ]
        },
        children: [
            {
                path: 'sailing-day-reports',
                name: 'manifests.sailing-day-reports',
                component: () => import('~/core/components/ParentPage'),
                meta: {
                    label: 'Sailing Day Reports',
                    icon: 'fa fa-list-alt',
                    permissions: [
                        'manifests.sailing-day-reports',
                    ]
                },
                children: [
                    {
                        path: 'obc-credit-report',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.obc-credit-report',
                        meta: {
                            legacyPath: '/admin/obc-credit-report',
                            label: 'OBC Credit Report',
                        }
                    },
                    {
                        path: 'notes-on-bookings-report',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.notes-on-bookings-report',
                        meta: {
                            legacyPath: '/admin/notes-on-bookings-report',
                            label: 'Notes On Bookings Report',
                        }
                    },
                    {
                        path: 'report-car-parking-manifest',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.report-car-parking-manifest',
                        meta: {
                            legacyPath: '/admin/report-car-parking-manifest',
                            label: 'Car Parking Manifest Report',
                        }
                    },
                    {
                        path: 'report-coach-manifest',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.report-coach-manifest',
                        meta: {
                            legacyPath: '/admin/report-coach-manifest',
                            label: 'Coach Manifest Report',
                        }
                    },
                    {
                        path: 'report-guest-manifest',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.report-guest-manifest',
                        meta: {
                            legacyPath: '/admin/report-guest-manifest',
                            label: 'Guest Manifest Report',
                        }
                    },
                    {
                        path: 'report-back-to-back-manifest',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.report-back-to-back-manifest',
                        meta: {
                            legacyPath: '/admin/report-back-to-back-manifest',
                            label: 'Back To Back Manifest Report',
                        }
                    },
                    {
                        path: 'report-embarkation-schedule-manifest',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.report-embarkation-schedule-manifest',
                        meta: {
                            legacyPath: '/admin/report-embarkation-schedule-manifest',
                            label: 'Embarkation Schedule Manifest Report',
                        }
                    },
                    {
                        path: 'report-staff-and-supernumerary-manifest',
                        component: () => import('~/core/components/LegacyPage'),
                        name: 'manifests.report-passenger-manifest.report-staff-and-supernumerary-manifest',
                        meta: {
                            legacyPath: '/admin/report-staff-and-supernumerary-manifest',
                            label: 'Staff & Supernumerary Manifest Report',
                        }
                    },
                ]
            },
            {
                path: 'report-passenger-manifest',
                component: () => import('~/core/components/LegacyPage'),
                name: 'manifests.report-passenger-manifest',
                meta: {
                    legacyPath: '/admin/report-passenger-manifest',
                    label: 'Passenger Manifest Report',
                }
            },
            {
                path: 'medical-insurance-manifest',
                component: () => import('~/core/components/LegacyPage'),
                name: 'manifests.medical-insurance-manifest',
                meta: {
                    legacyPath: '/admin/medical-insurance-manifest',
                    label: 'Medical & Insurance Manifest',
                }
            },
            {
                path: 'dietary-restaurant-seating-manifest',
                component: () => import('~/core/components/LegacyPage'),
                name: 'manifests.dietary-restaurant-seating-manifest',
                meta: {
                    legacyPath: '/admin/dietary-restaurant-seating-manifest',
                    label: 'Dietary & Restaurant Seating Manifest',
                }
            },
            {
                path: 'special-requests-list',
                component: () => import('~/core/components/LegacyPage'),
                name: 'manifests.special-requests-list',
                meta: {
                    legacyPath: '/admin/special-requests-list',
                    label: 'Special Requests',
                }
            },
            {
                path: 'required-documents',
                component: () => import('~/core/components/LegacyPage'),
                name: 'manifests.report-passenger-manifest.report-required-documents-manifest',
                meta: {
                    legacyPath: '/admin/required-documents',
                    label: 'Required Documents Manifest',
                }
            },
            {
                path: 'mail-merge-export',
                component: () => import('~/core/components/LegacyPage'),
                name: 'manifests.mail-merge-export',
                meta: {
                    legacyPath: '/admin/mail-merge-export',
                    label: 'Mail Merge Export',
                    permissions: [
                        'manifests.export-mailmerge-data',
                    ]
                }
            },

        ]
    },
    {
        path: '/manage/old-reports',
        name: 'old-reports',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Old Reports',
            icon: 'fa fa-table',
            permissions: [
                'reporting.view'
            ]
        },
        children: [
            {
                path: 'double-booking',
                component: () => import('~/core/components/LegacyPage'),
                name: 'old-reports.double-booking',
                meta: {
                    legacyPath: '/admin/double-booking',
                    label: 'Double Bookings Report',
                }
            },
            {
                path: 'report-recon',
                component: () => import('~/core/components/LegacyPage'),
                name: 'old-reports.report-recon',
                meta: {
                    legacyPath: '/admin/report-recon',
                    label: 'Financial Recon Report',
                }
            },
            {
                path: 'report-addresses',
                component: () => import('~/core/components/LegacyPage'),
                name: 'old-reports.report-addresses',
                meta: {
                    legacyPath: '/admin/report-addresses',
                    label: 'Address Report',
                }
            },

        ]
    },
    {
        path: '/manage/promotions-and-fares',
        name: 'promotions-and-fares',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Promotions & Fares',
            icon: 'fa fa-dot-circle',
            permissions: [
                'cabin.prices.view',
                'booking.additional-service-prices.view',
                'drinks-packages.view',
                'drinks-packages-discount.view',
                'bookings.promo-codes.view',
                'coaches.view',
                'parking.view',
            ]
        },
        children: [
            {
                path: 'cabin-farebases',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.cabin-farebases',
                meta: {
                    legacyPath: '/admin/cabin-farebases?sort=id&direction=desc',
                    label: 'Farebases',
                    permissions: [
                        'cabin-farebases.view'
                    ]
                }
            },
            {
                path: 'farebases',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.farebases',
                meta: {
                    legacyPath: '/admin/farebases',
                    label: 'Set Cruise Farebase',
                    permissions: [
                        'farebases.view'
                    ]
                }
            },
            {
                path: 'order-additional-services',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.order-additional-services',
                meta: {
                    legacyPath: '/admin/order-additional-services',
                    label: 'Additional Service Prices',
                    permissions: [
                        'booking.additional-service-prices.view'
                    ]
                }
            },
            {
                path: 'additions-packages',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.additions-packages',
                meta: {
                    legacyPath: '/admin/additions-packages',
                    label: 'Drinks Packages',
                    permissions: [
                        'drinks-packages.view'
                    ]
                }
            },
            {
                path: 'additions-packages-discount',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.additions-packages-discount',
                meta: {
                    legacyPath: '/admin/additions-packages-discount',
                    label: 'Drinks Packages Discounts',
                    permissions: [
                        'drinks-packages-discount.view'
                    ]
                }
            },
            {
                path: 'promo-codes',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.promo-codes',
                meta: {
                    legacyPath: '/admin/promo-codes',
                    label: 'Promo Codes',
                    permissions: [
                        'bookings.promo-codes.view'
                    ]
                }
            },
            {
                path: 'promo-codes-category',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.promo-codes-categories',
                meta: {
                    legacyPath: '/admin/promo-codes-categories',
                    label: 'Promo Code Categories',
                    permissions: [
                        'bookings.promo-codes-category.view'
                    ]
                }
            },
            {
                path: 'coaches',
                component: () => import('~/core/components/LegacyPage'),
                name: 'promotions-and-fares.coaches',
                meta: {
                    legacyPath: '/admin/coaches',
                    label: 'View Coaches',
                    permissions: [
                        'coaches.view'
                    ]
                }
            },
        ]
    },
    {
        path: '/manage/accounting',
        name: 'accounting',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Accounting Utilities',
            icon: 'fa fa-pound-sign',
            permissions: [
                'accounting.view'
            ]
        },
        children: [
            {
                path: 'payments',
                component: () => import('~/core/components/LegacyPage'),
                name: 'accounting.payments',
                meta: {
                    legacyPath: '/admin/payments',
                    label: 'View Payments',
                }
            },
            {
                path: 'cleared-payments',
                component: () => import('~/core/components/LegacyPage'),
                name: 'accounting.cleared-payments',
                meta: {
                    legacyPath: '/admin/cleared-payments',
                    label: 'Cleared Payments',
                }
            },
            {
                path: 'payment-accounts',
                component: () => import('~/core/components/LegacyPage'),
                name: 'accounting.payment-accounts',
                meta: {
                    legacyPath: '/admin/payment-accounts',
                    label: 'Bank Accounts',
                }
            },
            {
                path: 'payment-codes',
                component: () => import('~/core/components/LegacyPage'),
                name: 'accounting.payment-codes',
                meta: {
                    legacyPath: '/admin/payment-codes',
                    label: 'Nominal Codes',
                }
            },
            {
                path: 'promo-codes',
                component: () => import('~/core/components/LegacyPage'),
                name: 'accounting.promo-codes',
                meta: {
                    legacyPath: '/admin/promo-codes',
                    label: 'Promo Codes',
                    permissions: [
                        'bookings.promo-codes.view'
                    ]
                }
            },
            {
                path: 'agent-statements',
                component: () => import('~/core/components/LegacyPage'),
                name: 'accounting.agent-statements',
                meta: {
                    legacyPath: '/admin/agent-statements',
                    label: 'Agent Statements',
                }
            },
            {
                path: 'deposit-due-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'deposit.due-report',
                meta: {
                    legacyPath: '/admin/deposit-due-report',
                    label: 'Deposit Due Report',
                    permissions: [
                        'accounts.deposit-due-report.view',
                        'accounts.deposit-due-report.export'
                    ]
                }
            },
            {
                path: 'direct-debit-scheme-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'accounting.direct-debit-scheme-report',
                meta: {
                    legacyPath: '/admin/direct-debit-scheme-report',
                    label: 'Direct Debit Scheme Report',
                }
            },
        ]
    },
    {
        path: '/manage/cruise-management',
        name: 'cruise-management',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Cruise Management',
            icon: 'fa fa-ship',
            permissions: [
                'cruises.view'
            ]
        },
        children: [
            {
                path: 'cruises',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.cruises',
                meta: {
                    legacyPath: '/admin/cruises',
                    label: 'View Cruises',
                }
            },
            {
                path: 'cruises-log',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.cruises-log',
                meta: {
                    legacyPath: '/admin/cruises-log',
                    label: 'View Cruises Log',
                }
            },
            {
                path: 'ship-itinerary',
                component: () => import('~/domain/itinerary/pages/Itineraries'),
                name: 'cruise-management.ship-itinerary',
                meta: {
                    label: 'View Ships Itinerary',
                    permissions: [
                        'itinerary.view'
                    ]
                }
            },
            {
                path: 'new-ship-itinerary/:id',
                component: () => import('~/domain/itinerary/pages/CreateOrEditItinerary'),
                name: 'cruise-management.new-ship-itinerary',
                meta: {
                    label: 'New Ship Itinerary',
                    hiddenFromMenu: true,
                    permissions: [
                        'itinerary.edit'
                    ]
                }
            },
            {
                path: 'budgets',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.budgets',
                meta: {
                    legacyPath: '/admin/budgets',
                    label: 'Cruise Budgets',
                    permissions: [
                        'cost-centres.view'
                    ]
                },

            },
            {
                path: 'ships',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.ships',
                meta: {
                    legacyPath: '/admin/ships',
                    label: 'View Ships',
                }
            },
            {
                path: 'currencies',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.currencies',
                meta: {
                    legacyPath: '/admin/currencies',
                    label: 'View Currencies',
                }
            },
            {
                path: 'countries',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.countries',
                meta: {
                    legacyPath: '/admin/countries',
                    label: 'Countries',
                }
            },
            {
                path: 'ports',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.ports',
                meta: {
                    legacyPath: '/admin/ports',
                    label: 'Ports',
                }
            },
            {
                path: 'destinations',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.destinations',
                meta: {
                    legacyPath: '/admin/destinations',
                    label: 'Destinations',
                }
            },
            {
                path: 'cabins',
                component: () => import('~/core/components/LegacyPage'),
                name: 'cruise-management.cabins',
                meta: {
                    legacyPath: '/admin/cabins',
                    label: 'Full Cabin Inventory',
                }
            },

        ]
    },
    {
        path: '/manage/agent-management',
        name: 'agent-management',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Travel Partner Management',
            icon: 'fas fa-store-alt',
            permissions: [
                'travel-partners.list',
            ]
        },
        children: [
            {
                path: 'sales-report',
                component: () => import('~/core/components/LegacyPage'),
                name: 'investor-sales-report',
                meta: {
                    legacyPath: '/admin/sales-report',
                    label: 'Cumulative Sales Report',
                    permissions: [
                        'travel-partners.list',
                    ]
                }
            },
            {
                path: 'travel-partners',
                component: () => import('~/core/components/LegacyPage'),
                name: 'travel-partner-management.agents',
                meta: {
                    legacyPath: '/admin/agents',
                    label: 'View Agents',
                }
            },
            {
                path: 'commission-season',
                component: () => import('~/core/components/LegacyPage'),
                name: 'travel-partner-management.commission-season',
                meta: {
                    legacyPath: '/admin/commission-season',
                    label: 'Commission Seasons',
                }
            },
            {
                path: 'agents-allocations',
                component: () => import('~/core/components/LegacyPage'),
                name: 'travel-partner-management.agents-allocations',
                meta: {
                    legacyPath: '/admin/agents-allocations',
                    label: 'Agent\'s Allocations',
                }
            },
            {
                path: 'group-contracts',
                component: () => import('~/core/components/LegacyPage'),
                name: 'travel-partner-management.group-contracts',
                meta: {
                    legacyPath: '/admin/wave-group-contracts',
                    label: 'Group Contracts',
                    hiddenFromMenu: true,
                }
            },
            {
                path: 'group-data-reporting',
                component: () => import('~/core/components/LegacyPage'),
                name: 'booking-reports.group-data-reporting',
                meta: {
                    legacyPath: '/admin/group-data-reporting',
                    label: 'Group Data Reporting',
                }
            },

        ],
    },
    {
        path: '/manage/user-management',
        name: 'user-management',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'User Management',
            icon: 'ion-person',
            permissions: [
                'auth.view',
                'users.view',
                'teams.view',
                'roles.view',
                'permission-keys.view',
            ]
        },
        children: [
            {
                path: 'users',
                component: () => import('~/domain/users/pages/Users'),
                name: 'users',
                meta: {
                    label: 'Users',
                    hideChildren: true,
                    icon: 'ion-person',
                    sectionLink: 'index',
                    permissions: ['auth.view']
                },
                children: [
                    {
                        path: 'index',
                        component: () => import('./domain/users/pages/users/Index'),
                        name: 'users.index'
                    },
                    {
                        path: 'create',
                        name: 'users.create',
                        component: () => import('./domain/users/pages/users/Create')
                    },
                    {
                        path: 'edit/:id',
                        name: 'users.edit',
                        component: () => import('./domain/users/pages/users/Edit')
                    }
                ]
            },
            {
                path: 'permissions',
                component: () => import('~/domain/permissions/pages/Permissions'),
                name: 'permissions',
                meta: {
                    label: 'Permissions',
                    hideChildren: true,
                    icon: 'ion-locked',
                    sectionLink: 'index'
                },
                children: [
                    {
                        path: 'index',
                        name: 'permissions.index',
                        component: () => import('./domain/permissions/pages/permissions/Index')
                    },
                    {
                        path: 'create',
                        name: 'permissions.create',
                        component: () => import('~/core/components/Page')
                    },
                    {
                        path: 'edit/:id',
                        name: 'permissions.edit',
                        component: () => import('./domain/permissions/pages/permissions/Edit')
                    }
                ]
            },
            {
                path: 'permission-keys',
                component: () => import('~/core/components/Page'),
                name: 'permissionKeys',
                meta: {
                    label: 'Permission Keys',
                    hideChildren: true,
                    icon: 'ion-locked',
                    sectionLink: 'index',
                    permissions: ['permission-keys.view']
                },
                children: [
                    {
                        path: 'index',
                        name: 'permissionKeys.index',
                        component: () => import('~/core/components/Page')
                    }
                ]
            }
        ]
    },
    {
        path: '/manage/system-configuration',
        name: 'system-configuration',
        component: () => import('~/core/components/Page'),
        meta: {
            label: 'System Configuration',
            icon: 'ion-settings',
            permissions: [
                'config.view',
            ]
        },
        children: [
            {
                path: 'settings',
                component: () => import('~/core/components/LegacyPage'),
                name: 'system-configuration.settings',
                meta: {
                    legacyPath: '/admin/settings',
                    label: 'Settings',
                }
            },
            {
                path: 'systemlog',
                component: () => import('~/core/components/LegacyPage'),
                name: 'system-configuration.systemlog',
                meta: {
                    legacyPath: '/admin/systemlog',
                    label: 'System Log',
                }
            },
            {
                path: 'uploads',
                component: () => import('~/core/components/LegacyPage'),
                name: 'system-configuration.uploads',
                meta: {
                    legacyPath: '/admin/uploads',
                    label: 'Uploads CSV',
                }
            },
            {
                path: 'api-logs',
                component: () => import('~/core/components/LegacyPage'),
                name: 'system-configuration.api-logs',
                meta: {
                    legacyPath: '/admin/api-logs',
                    label: 'API Logs',
                }
            },
        ]
    },
    {
        path: '/manage/development',
        name: 'development',
        component: () => import('~/core/components/Page'),
        meta: {
            label: 'Development',
            icon: 'fa fa-code',
            permissions: ['developer']
        },
        children: [
            {
                path: '/api-client',
                component: () => import('~/core/components/Page'),
                name: 'api-client',
                meta: {
                    label: 'Api Client',
                    hideChildren: true,
                    icon: 'fa fa-grav',
                    sectionLink: 'index',
                    permissions: [
                        'something.no.one.has'
                    ]
                },
                children: [
                    {
                        path: 'index',
                        name: 'api-client.index',
                        component: () => import('~/core/components/Page')
                    }
                ]
            },
            {
                path: 'designs',
                component: () => import('~/core/components/Page'),
                name: 'designs',
                meta: {
                    label: 'Component Designs',
                    icon: 'ion-paintbrush',
                    hideChildren: true,
                },
            }
        ]
    },
    {
        path: '/manage/marketing',
        name: 'marketing',
        component: () => import('~/core/components/ParentPage'),
        meta: {
            label: 'Marketing',
            icon: 'fa fa-list-alt',
            permissions: [
                'marketing.marketing-advert-spend.view'
            ]
        },
        children: [
            {
                path: 'marketing-advert-information',
                component: () => import('~/core/components/LegacyPage'),
                name: 'marketing.marketing-advert-information',
                meta: {
                    legacyPath: '/admin/marketing-advert-information',
                    label: 'Marketing Advert Information',
                    permissions: [
                        'marketing.marketing-advert-spend.view'
                    ]
                }
            }
        ]
    },
]
